"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActiveBasket = void 0;
var _react = _interopRequireWildcard(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _reactRedux = require("react-redux");
var _Modal = _interopRequireDefault(require("../../../../Modal"));
var _Offer = _interopRequireDefault(require("../../../../Baskets/components/Results/components/Offer"));
var _BasketActions = require("../../../../Baskets/components/BasketActions");
var _Claim = require("../../../../Baskets/components/Results/components/Claim");
var _Button = _interopRequireWildcard(require("../../../../ui/Button"));
var _pluralTranslations = require("../../../../../localization/pluralTranslations");
var _selectors = require("../../store/selectors");
var _actions = require("../../store/actions");
var _styles = _interopRequireDefault(require("./styles"));
var _goBack = _interopRequireDefault(require("./img/go-back.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ActiveBasketPure = function ActiveBasketPure(_ref) {
  var basketID = _ref.basketID,
    title = _ref.title,
    discount = _ref.discount,
    margin = _ref.margin,
    showPriceWithMargin = _ref.showPriceWithMargin,
    offersIDs = _ref.offersIDs,
    basketURL = _ref.basketURL,
    date = _ref.date,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    onSuccessDeleted = _ref.onSuccessDeleted,
    claim = _ref.claim;
  var deleteActiveBasketUI = (0, _reactRedux.useSelector)(_selectors.getDeleteActiveBasketUi);
  var toursTranslation = (0, _pluralTranslations.usePluralToursTranslation)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var onRemove = (0, _react.useCallback)(function (offerID) {
    return dispatch((0, _actions.removeOfferFromActiveBasket)(offerID, basketID));
  }, [basketID, dispatch]);
  var onShowOfferInSearch = (0, _react.useCallback)(function (hotelID, offerID) {
    return dispatch((0, _actions.startSearchByOffer)(hotelID, offerID));
  }, [dispatch]);
  var onDelete = (0, _react.useCallback)(function () {
    return dispatch((0, _actions.removeBasket)(basketID, onSuccessDeleted));
  }, [basketID, dispatch, onSuccessDeleted]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.root
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.modalHeader
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    icon: _goBack.default,
    theme: _Button.THEMES.TRANSPARENT,
    onClick: onClose
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.modalHeaderTitle
  }, title)), claim && /*#__PURE__*/_react.default.createElement(_Claim.Claim, {
    description: claim.claimDesc,
    claimID: claim.id,
    className: _styles.default.claim,
    link: claim.claimLink,
    basketID: basketID
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.modalHeaderBody
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.modalHeaderInfo
  }, /*#__PURE__*/_react.default.createElement("div", null, "".concat(offersIDs.length, " ").concat(toursTranslation(offersIDs.length))), /*#__PURE__*/_react.default.createElement("div", null, (0, _moment.default)(date).format('DD MMM HH:mm'))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.modalHeaderButtons
  }, /*#__PURE__*/_react.default.createElement(_BasketActions.OpenButton, {
    basketID: basketID,
    onClick: onOpen
  }), /*#__PURE__*/_react.default.createElement(_BasketActions.CopyButton, {
    content: basketURL
  }), /*#__PURE__*/_react.default.createElement(_BasketActions.DeleteButton, {
    loading: deleteActiveBasketUI.loading,
    onDelete: onDelete
  })))), /*#__PURE__*/_react.default.createElement(_Modal.default.Content, {
    className: _styles.default.modalContent
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.list
  }, R.map(function (offerID) {
    return /*#__PURE__*/_react.default.createElement(_Offer.default, {
      isMobile: true,
      basketID: basketID,
      className: _styles.default.offer,
      discount: discount,
      margin: margin,
      key: offerID,
      offerID: offerID,
      showPriceWithMargin: showPriceWithMargin,
      onRemove: onRemove,
      onSearchOffer: onShowOfferInSearch
    });
  }, offersIDs))));
};
ActiveBasketPure.propTypes = {
  basketID: _propTypes.default.number.isRequired,
  title: _propTypes.default.string.isRequired,
  offersIDs: _propTypes.default.array.isRequired,
  discount: _propTypes.default.number,
  margin: _propTypes.default.number,
  showPriceWithMargin: _propTypes.default.bool,
  basketURL: _propTypes.default.string,
  date: _propTypes.default.string,
  claim: _propTypes.default.object,
  onOpen: _propTypes.default.func,
  onClose: _propTypes.default.func,
  onSuccessDeleted: _propTypes.default.func
};
var ActiveBasket = exports.ActiveBasket = (0, _react.memo)(ActiveBasketPure);